import { About } from './interfaces';

export const getAbout = async (): Promise<About> => {
  return (await fetch(process.env.REACT_APP_STRAPI_URL + 'about')).json();
};
